import { MapDelta } from "./map/map"
import { ObjectPool, ObjectPoolItem } from "./object_pool"

export interface MapDeltaArrayPoolItem extends ObjectPoolItem<MapDelta[]> {}

export class MapDeltasArrayPool extends ObjectPool<MapDelta[]> {
    static instance: MapDeltasArrayPool = new MapDeltasArrayPool()

    constructor(size: number = 1000) {
        super(size)
    }

    create(): MapDeltaArrayPoolItem {
        return {
            free: true,
            data: [],
        }
    }

    clear(item: MapDeltaArrayPoolItem) {
        item.data.length = 0
    }

    // Convenience method to get a fresh array
    checkoutArray(): MapDeltaArrayPoolItem {
        return this.checkout()
    }
}
